import { createContext, useContext } from "react";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import axiosInstance from "../api/axiosInstance";
import { setAuthReady, setSessionUser, updateUserInfo } from "../features/authSlice";
const authContext = createContext();
export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    let active = true;
    axiosInstance.get("/api/auth/session", { _skipAuthRetry: true })
      .then((res) => {
        if (active) dispatch(setSessionUser(res.data.data.user));
      })
      .catch(() => {})
      .finally(() => {
        if (active) dispatch(setAuthReady(true));
      });
    return () => { active = false; };
  }, [dispatch]);
  const fetchUser = async (username = null) => {
    try {
      const url = username
        ? `/api/user/details?username=${encodeURIComponent(username)}`
        : `/api/user/details`;
      const res = await axiosInstance.get(url);
      if (!username) {
        dispatch(updateUserInfo(res.data.data.user)); 
      }
      return res.data.data.user;
    } catch (err) {
      return null;
    }
  };
  return (
    <authContext.Provider value={{ fetchUser }}>
      {children}
    </authContext.Provider>
  );
};
export const useAuth = () => useContext(authContext);
